import React, { use, useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ApplicationInformation from "../../Pages/Manager/ApplicationInformation";
import YesNo from "../../Pages/Manager/YesNo";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetSpecificTaskById,
  UpdateMainTasks,
} from "../../Redux/Reducers/Manager/Tasks/TasksByRoundAndFiled";
import { useDispatch, useSelector } from "react-redux";
import { WorkFlowStep } from "../../Redux/Reducers/Manager/WorkFlowStep";
import ButtonAHSF from "../../Components/ButtonAHSF";
import {
  UpdateYesNoList,
  ValidationYesNoList,
} from "../../Redux/Reducers/Manager/YesNo";
import Swal from "sweetalert2";

function InitialScreeningEvaluation() {
  const userInfo = useSelector((state) => state.UserInfo.UserInfo.userToken);

  const { taskId } = useParams();
  const navigate = useNavigate();
  const [taskDisabledStatus, setTaskDisabledStatus] = useState(false);
  const dispatch = useDispatch();
  const applicationGuid = useSelector(
    (state) => state.TasksByRoundAndFiled.SpecificTask
  );

  const state = useSelector((state) => {
    return {
      YesNoManagerValidation: state.YesNoManager.YesNoManagerValidation,
    };
  });
  console.log(state.YesNoManagerValidation, "vali");

  const [yesNoData, setYesNoData] = useState({});

  console.log(
    applicationGuid?.applicationInformationId,
    "applicaddddddddtionGuid"
  );
  console.log(applicationGuid?.taskStatusId, "applicddddddddsssationGuid");
  useEffect(() => {
    if (
      applicationGuid?.taskStatusId == "1953e284-81d8-4c04-ac72-645d0c9a22b0" ||
      (applicationGuid?.taskStatusId ==
        "01d1da92-c354-4d0d-9453-e835deb6bc82" &&
        applicationGuid?.userId == userInfo.userGuid &&
        applicationGuid?.userId != null)
    ) {
      setTaskDisabledStatus(true);
    } else {
      setTaskDisabledStatus(false);
    }
  }, [applicationGuid]);
  useEffect(() => {
    dispatch(GetSpecificTaskById({ taskId: taskId }));
  }, [taskId]);

  
  const Save= async()=>{
    const allYesNoItems = Object.values(yesNoData).flatMap(
      (group) => group.value
    );

    // First, update the Yes/No list
    let resultUpdateYesNoList = await dispatch(
      UpdateYesNoList({
        eV_NT_YesNoEvaluationModel: allYesNoItems,
      })
    );
    Swal.fire({
          position: "center",
          icon: "success",
          title: "تم الحفظ بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
  }
  const addWorkFlowStep = async () => {
    // Flatten all group values into a single array
    const allYesNoItems = Object.values(yesNoData).flatMap(
      (group) => group.value
    );

    // First, update the Yes/No list
    let resultUpdateYesNoList = await dispatch(
      UpdateYesNoList({
        eV_NT_YesNoEvaluationModel: allYesNoItems,
      })
    );

    // Then validate (after saving)
    let resultValidation = await dispatch(
      ValidationYesNoList({ taskId: taskId })
    );

    console.log(resultValidation.payload, "validation result");

    if (resultUpdateYesNoList.payload.success) {
      if (resultValidation.payload.length === 0) {
        await dispatch(
          UpdateMainTasks({
            tasksId: taskId,
            tasksStatus: "1953e284-81d8-4c04-ac72-645d0c9a22b0",
          })
        );
        navigate("/SRFund/manager/TransferRequestsStatus/");
      } else {
        Swal.fire({
          title: "الرجاء تعبئة الحقول التالية",
          html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">${resultValidation.payload
              .map(
                (msg) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${msg}</strong></li>`
              )
              .join("")}</ul>`,
          icon: "warning",
          confirmButtonText: "حسناً",
        });
      }
    }
  };

  return (
    <>
      <ApplicationInformation
        applicationGuid={applicationGuid?.applicationInformationId}
      />
      <YesNo
        disabled={taskDisabledStatus}
        taskId={taskId}
        onDataChange={(updatedData) => setYesNoData(updatedData)}
      />
      {!taskDisabledStatus ? (
        <>
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={addWorkFlowStep}
                disabled={false}
                // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                text={"الانتهاء من التقييم"}
                show={true}
              />
            </div>

            <>
              <div className="SaveButtonMarks">
                <ButtonAHSF
                  type={"submitter"}
                  onClick={Save}
                  disabled={false}
                  // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  text={"حفظ"}
                  show={true}
                />
              </div>
            </>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default InitialScreeningEvaluation;
